module.exports = {
  "addison": {
    "latitude": 41.922536,
    "longitude": -87.977371
  },
  "albany park": {
    "latitude": 41.969702,
    "longitude": -87.729106
  },
  "alsip": {
    "latitude": 41.66832821,
    "longitude": -87.73176125
  },
  "andersonville": {
    "latitude": 41.979495,
    "longitude": -87.673479
  },
  "arlington heights": {
    "latitude": 42.0862145,
    "longitude": -87.9779316
  },
  "aurora": {
    "latitude": 41.773999,
    "longitude": -88.283718
  },
  "barrington": {
    "latitude": 42.15573996,
    "longitude": -88.13615801
  },
  "barrington hills": {
    "latitude": 42.11428266,
    "longitude": -88.18251308
  },
  "bartlett": {
    "latitude": 41.99057232,
    "longitude": -88.18452803
  },
  "batavia": {
    "latitude": 41.852491,
    "longitude": -88.292857
  },
  "bedford park": {
    "latitude": 41.7710902,
    "longitude": -87.81798651
  },
  "bellwood": {
    "latitude": 41.88181485,
    "longitude": -87.87235963
  },
  "bensenville": {
    "latitude": 41.956492,
    "longitude": -87.94108707
  },
  "berkeley": {
    "latitude": 41.88213328,
    "longitude": -87.9139054
  },
  "berwyn": {
    "latitude": 41.84326382,
    "longitude": -87.79079012
  },
  "beverly": {
    "latitude": 41.71767,
    "longitude": -87.672835
  },
  "blue island": {
    "latitude": 41.65540888,
    "longitude": -87.67960954
  },
  "bolingbrook": {
    "latitude": 41.707754,
    "longitude": -88.06195
  },
  "bridgeview": {
    "latitude": 41.75501275,
    "longitude": -87.80484271
  },
  "broadview": {
    "latitude": 41.86105518,
    "longitude": -87.86274847
  },
  "brookfield": {
    "latitude": 41.82256421,
    "longitude": -87.84265115
  },
  "buffalo grove": {
    "latitude": 42.15284889,
    "longitude": -87.96762412
  },
  "burbank": {
    "latitude": 41.75574765,
    "longitude": -87.76209428
  },
  "burnham": {
    "latitude": 41.63178109,
    "longitude": -87.55603699
  },
  "burr ridge": {
    "latitude": 41.74943042,
    "longitude": -87.91555711
  },
  "calumet city": {
    "latitude": 41.61548808,
    "longitude": -87.55417963
  },
  "calumet park": {
    "latitude": 41.64627568,
    "longitude": -87.63166675
  },
  "chicago": {
    "latitude": 41.8369732,
    "longitude": -87.70195
  },
  "chicago heights": {
    "latitude": 41.50236635,
    "longitude": -87.64053807
  },
  "chicago ridge": {
    "latitude": 41.69403802,
    "longitude": -87.7789476
  },
  "cicero": {
    "latitude": 41.85116894,
    "longitude": -87.74682521
  },
  "country club hills": {
    "latitude": 41.55996649,
    "longitude": -87.7211391
  },
  "countryside": {
    "latitude": 41.78968672,
    "longitude": -87.85890212
  },
  "crestwood": {
    "latitude": 41.64102883,
    "longitude": -87.73788647
  },
  "darien": {
    "latitude": 41.753324,
    "longitude": -87.962435
  },
  "deer park": {
    "latitude": 42.17578736,
    "longitude": -88.09557003
  },
  "deerfield": {
    "latitude": 42.1686121,
    "longitude": -87.84615633
  },
  "des plaines": {
    "latitude": 42.0361844,
    "longitude": -87.9024015
  },
  "dixmoor": {
    "latitude": 41.62622463,
    "longitude": -87.65709708
  },
  "dolton": {
    "latitude": 41.64016724,
    "longitude": -87.60997886
  },
  "downers grove": {
    "latitude": 41.796156,
    "longitude": -87.999368
  },
  "east hazel crest": {
    "latitude": 41.57427808,
    "longitude": -87.66281975
  },
  "elgin": {
    "latitude": 42.03959857,
    "longitude": -88.28430333
  },
  "elk grove village": {
    "latitude": 42.0103211,
    "longitude": -87.9953895
  },
  "elmhurst": {
    "latitude": 41.90366147,
    "longitude": -87.93984264
  },
  "elmwood park": {
    "latitude": 41.87650883,
    "longitude": -87.65365682
  },
  "evanston": {
    "latitude": 42.047072,
    "longitude": -87.691597
  },
  "evergreeen park": {
    "latitude": 41.72220146,
    "longitude": -87.70194895
  },
  "flossmoor": {
    "latitude": 41.54253892,
    "longitude": -87.68543758
  },
  "ford heights": {
    "latitude": 41.50752152,
    "longitude": -87.59206436
  },
  "forest park": {
    "latitude": 41.98286588,
    "longitude": -88.19171623
  },
  "forest view": {
    "latitude": 41.80859726,
    "longitude": -87.79711893
  },
  "frankfort": {
    "latitude": 41.4975663,
    "longitude": -87.85986556
  },
  "franklin park": {
    "latitude": 41.93686749,
    "longitude": -87.86383118
  },
  "glencoe": {
    "latitude": 42.13378238,
    "longitude": -87.75815545
  },
  "glenview": {
    "latitude": 42.084098,
    "longitude": -87.815855
  },
  "glenwood": {
    "latitude": 41.54607985,
    "longitude": -87.61241837
  },
  "gurnee": {
    "latitude": 42.349529,
    "longitude": -87.92323
  },
  "hanover park": {
    "latitude": 41.99091029,
    "longitude": -88.15809651
  },
  "harvey": {
    "latitude": 41.61131742,
    "longitude": -87.64461196
  },
  "harwood heights": {
    "latitude": 41.96361771,
    "longitude": -87.80968085
  },
  "hazel crest": {
    "latitude": 41.57927677,
    "longitude": -87.6875503
  },
  "hickory hills": {
    "latitude": 41.71828833,
    "longitude": -87.83429098
  },
  "highland park": {
    "latitude": 42.158114,
    "longitude": -87.809846
  },
  "hillside": {
    "latitude": 41.87771049,
    "longitude": -87.90810415
  },
  "hinsdale": {
    "latitude": 41.80369828,
    "longitude": -87.92872078
  },
  "hodgkins": {
    "latitude": 41.77191259,
    "longitude": -87.85609015
  },
  "hoffman estates": {
    "latitude": 42.063272,
    "longitude": -88.136186
  },
  "homer glen": {
    "latitude": 41.6187235,
    "longitude": -87.93220455
  },
  "hometown": {
    "latitude": 41.72896664,
    "longitude": -87.72986311
  },
  "homewood": {
    "latitude": 41.56260794,
    "longitude": -87.66581328
  },
  "huntley": {
    "latitude": 42.170763,
    "longitude": -88.402694
  },
  "indian head park": {
    "latitude": 41.77154858,
    "longitude": -87.89472223
  },
  "inverness": {
    "latitude": 42.12457362,
    "longitude": -88.07792311
  },
  "justice": {
    "latitude": 41.74907551,
    "longitude": -87.8394754
  },
  "kenilworth": {
    "latitude": 42.08660912,
    "longitude": -87.71649111
  },
  "lagrange": {
    "latitude": 41.81375518,
    "longitude": -87.86954778
  },
  "lagrange park": {
    "latitude": 41.82234469,
    "longitude": -87.87371862
  },
  "lake forest": {
    "latitude": 42.219385,
    "longitude": -87.86825
  },
  "lake zurich": {
    "latitude": 42.17799,
    "longitude": -88.081572
  },
  "lansing": {
    "latitude": 41.56477435,
    "longitude": -87.54083264
  },
  "lemont": {
    "latitude": 41.67466029,
    "longitude": -87.99829623
  },
  "libertyville": {
    "latitude": 42.272792,
    "longitude": -87.954695
  },
  "lilse": {
    "latitude": 41.798092,
    "longitude": -88.069426
  },
  "lincolnshire": {
    "latitude": 42.184626,
    "longitude": -87.902221
  },
  "lincolnwood": {
    "latitude": 42.00658745,
    "longitude": -87.7328202
  },
  "lynwood": {
    "latitude": 41.50516563,
    "longitude": -87.53276112
  },
  "lyons": {
    "latitude": 41.81513886,
    "longitude": -87.82574988
  },
  "markham": {
    "latitude": 41.59013091,
    "longitude": -87.69416345
  },
  "matteson": {
    "latitude": 41.51712934,
    "longitude": -87.73436703
  },
  "maywood": {
    "latitude": 41.87908876,
    "longitude": -87.83016567
  },
  "mccook": {
    "latitude": 41.80067034,
    "longitude": -87.83257186
  },
  "melrose park": {
    "latitude": 41.8958436,
    "longitude": -87.86414472
  },
  "merrionette park": {
    "latitude": 41.67973161,
    "longitude": -87.7004195
  },
  "midlothian": {
    "latitude": 41.62362295,
    "longitude": -87.71759651
  },
  "mokena": {
    "latitude": 41.544299,
    "longitude": -87.853539
  },
  "morton grove": {
    "latitude": 42.03814391,
    "longitude": -87.77977646
  },
  "mount prospect": {
    "latitude": 42.06538695,
    "longitude": -87.9354176
  },
  "naperville": {
    "latitude": 41.764489,
    "longitude": -88.122402
  },
  "niles": {
    "latitude": 42.02566684,
    "longitude": -87.80120739
  },
  "norridge": {
    "latitude": 41.95268257,
    "longitude": -87.81460751
  },
  "north riverside": {
    "latitude": 41.84553119,
    "longitude": -87.82292552
  },
  "northbrook": {
    "latitude": 42.1305724,
    "longitude": -87.83150106
  },
  "northfield": {
    "latitude": 42.10062877,
    "longitude": -87.77004341
  },
  "northlake": {
    "latitude": 41.9070621,
    "longitude": -87.90026878
  },
  "oak brook": {
    "latitude": 41.83248804,
    "longitude": -87.9467609
  },
  "oak forest": {
    "latitude": 41.61128853,
    "longitude": -87.75631293
  },
  "oak lawn": {
    "latitude": 41.72045991,
    "longitude": -87.75272577
  },
  "oak park": {
    "latitude": 41.87998807,
    "longitude": -87.77852438
  },
  "olympia fields": {
    "latitude": 41.52493826,
    "longitude": -87.70107829
  },
  "orland hills": {
    "latitude": 41.59831269,
    "longitude": -87.84779172
  },
  "orland park": {
    "latitude": 41.62307419,
    "longitude": -87.85606043
  },
  "palatine": {
    "latitude": 42.11308817,
    "longitude": -88.03874773
  },
  "palos heights": {
    "latitude": 41.67509463,
    "longitude": -87.80661835
  },
  "palos hills": {
    "latitude": 41.70303037,
    "longitude": -87.81723346
  },
  "palos park": {
    "latitude": 41.66712504,
    "longitude": -87.83997841
  },
  "park forest": {
    "latitude": 41.48176549,
    "longitude": -87.68108037
  },
  "park ridge": {
    "latitude": 42.00858826,
    "longitude": -87.83037588
  },
  "phoenix": {
    "latitude": 41.61535731,
    "longitude": -87.63241659
  },
  "posen": {
    "latitude": 41.62634115,
    "longitude": -87.68036962
  },
  "prospect heights": {
    "latitude": 42.09638938,
    "longitude": -87.93680749
  },
  "richton park": {
    "latitude": 41.48428737,
    "longitude": -87.72465067
  },
  "river forest": {
    "latitude": 41.88690408,
    "longitude": -87.81958335
  },
  "river grove": {
    "latitude": 41.92724104,
    "longitude": -87.83564809
  },
  "riverdale": {
    "latitude": 41.63357728,
    "longitude": -87.62592539
  },
  "riverside": {
    "latitude": 41.82657688,
    "longitude": -87.81885243
  },
  "robbins": {
    "latitude": 41.64419099,
    "longitude": -87.70278265
  },
  "rolling meadows": {
    "latitude": 42.08015086,
    "longitude": -88.02528553
  },
  "roselle": {
    "latitude": 41.9826995,
    "longitude": -88.07766357
  },
  "rosemont": {
    "latitude": 41.99571337,
    "longitude": -87.86328961
  },
  "sauk village": {
    "latitude": 41.49369077,
    "longitude": -87.55803218
  },
  "schaumburg": {
    "latitude": 42.02619769,
    "longitude": -88.06952022
  },
  "schiller park": {
    "latitude": 41.9547163,
    "longitude": -87.86500266
  },
  "skokie": {
    "latitude": 42.02631473,
    "longitude": -87.7552769
  },
  "south barrington": {
    "latitude": 42.07338194,
    "longitude": -88.1412411
  },
  "south chicago heights": {
    "latitude": 41.47835572,
    "longitude": -87.63730156
  },
  "south holland": {
    "latitude": 41.60051746,
    "longitude": -87.61004372
  },
  "south shore": {
    "latitude": 41.757325,
    "longitude": -87.589572
  },
  "steger": {
    "latitude": 41.46982054,
    "longitude": -87.63787613
  },
  "stickney": {
    "latitude": 41.82140221,
    "longitude": -87.78653973
  },
  "stone park": {
    "latitude": 41.90130131,
    "longitude": -87.88370691
  },
  "streamwood": {
    "latitude": 42.01214013,
    "longitude": -88.17587959
  },
  "summit": {
    "latitude": 41.78451084,
    "longitude": -87.80415698
  },
  "thornton": {
    "latitude": 41.56837418,
    "longitude": -87.61194063
  },
  "tinley park": {
    "latitude": 41.59577318,
    "longitude": -87.78513062
  },
  "university park": {
    "latitude": 41.44679372,
    "longitude": -87.68649585
  },
  "vernon hills": {
    "latitude": 42.220998,
    "longitude": -87.955201
  },
  "villa park": {
    "latitude": 41.887719,
    "longitude": -87.965587
  },
  "westchester": {
    "latitude": 41.86332635,
    "longitude": -87.88062191
  },
  "western springs": {
    "latitude": 41.81006434,
    "longitude": -87.89800794
  },
  "wheaton": {
    "latitude": 41.88023,
    "longitude": -88.086351
  },
  "wheeling": {
    "latitude": 42.13840811,
    "longitude": -87.92298656
  },
  "willowbrook": {
    "latitude": 41.772462,
    "longitude": -87.928088
  },
  "willow springs": {
    "latitude": 41.733997,
    "longitude": -87.87700748
  },
  "wilmette": {
    "latitude": 42.07563674,
    "longitude": -87.7077437
  },
  "winnetka": {
    "latitude": 42.10512602,
    "longitude": -87.7336786
  },
  "wood dale": {
    "latitude": 41.965208,
    "longitude": -87.970695
  },
  "worth": {
    "latitude": 41.69005391,
    "longitude": -87.7954954
  },
  "zion": {
    "latitude": 0,
    "longitude": 0
  }
}